import { render } from "./MapButton.vue?vue&type=template&id=01f9c439"
import script from "./MapButton.vue?vue&type=script&lang=js"
export * from "./MapButton.vue?vue&type=script&lang=js"

import exportComponent from "/builds/prohemo/education/mental-maps/metal-maps-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__